import { IStyle } from "./../../../Types/Style";
import { createAction } from "redux-actions";

import { ICompleteOrganization } from "../../types/common";

export enum Action {
  ADD_NEW_THEME = "THEMES_LIST/ADD_NEW_THEME",
  HANDLE_ADD_NEW_THEME_FAILURE = "THEMES_LIST/HANDLE_ADD_NEW_THEME_FAILURE",
  HANDLE_ADD_NEW_THEME_SUCCESS = "THEMES_LIST/HANDLE_ADD_NEW_THEME_SUCCESS",
  MOUNT = "THEMES_LIST/MOUNT",
  HANDLE_FETCH_EDITABLE_THEMES_SUCCESS = "THEMES_LIST/HANDLE_FETCH_EDITABLE_THEMES_SUCCESS",
  HANDLE_FETCH_EDITABLE_THEMES_FAILURE = "THEMES_LIST/HANDLE_FETCH_EDITABLE_THEMES_FAILURE",
  DELETE_THEME = "THEMES_LIST/DELETE_THEME",
  HANDLE_DELETE_THEME_SUCCESS = "THEMES_LIST/HANDLE_DELETE_THEME_SUCCESS",
  HANDLE_DELETE_THEME_FAILURE = "THEMES_LIST/HANDLE_DELETE_THEME_FAILURE",
  UNMOUNT = "THEMES_LIST/UNMOUNT",
}

export interface IFirstFetchPayload {
  styles: IStyle[];
  fullOrganization: ICompleteOrganization;
}

export const mount = createAction<void>(Action.MOUNT);
export const handleFetchEditableThemesSuccess = createAction<IFirstFetchPayload>(
  Action.HANDLE_FETCH_EDITABLE_THEMES_SUCCESS
);
export const handleFetchEditableThemesFailure = createAction<{
  message: string;
}>(Action.HANDLE_FETCH_EDITABLE_THEMES_FAILURE);
export const unmount = createAction<void>(Action.UNMOUNT);
export const deleteTheme = createAction<string>(Action.DELETE_THEME);
export const handleDeleteThemeSuccess = createAction<IStyle[]>(Action.HANDLE_DELETE_THEME_SUCCESS);
export const handleDeleteThemeFailure = createAction<{ message: string }>(Action.HANDLE_DELETE_THEME_FAILURE);
export const addNewTheme = createAction<void>(Action.ADD_NEW_THEME);
export const handleAddNewThemeFailure = createAction<{ message: string }>(Action.HANDLE_ADD_NEW_THEME_FAILURE);
export const handleAddNewThemeSuccess = createAction<void>(Action.HANDLE_ADD_NEW_THEME_SUCCESS);
